export const StringUtil = {
  /**
   * 去两端空格
   * @returns {trim}
   */
  trim (str) {
    if (typeof str === 'string') {
      return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
    return str;
  },
  /**
   * 转换字符串，undefined,null等转化为""
   * @param str
   * @returns {*}
   */
  parseString(str) {
    if (!str || str == "undefined" || str == "null") {
      return "";
    }
    return str;
  },
  /**
   *
   * @returns {string}
   */
  getUuid() {
    const timestamp = +new Date() + '';
    const randomNum = parseInt((1 + Math.random()) * 65536) + '';
    return (+(randomNum + timestamp)).toString(32);
  },
  // 首字母大小
  titleCase(str) {
    return str.replace(/( |^)[a-z]/g, L => L.toUpperCase())
  },
  // 下划转驼峰
  camelCase(str) {
    return str.replace(/-[a-z]/g, str1 => str1.substr(-1).toUpperCase())
  },
  /**
   * @param {string} input value
   * @returns {number} output value
   */
  byteLength(str) {
    // returns the byte length of an utf8 string
    let s = str.length
    for (var i = str.length - 1; i >= 0; i--) {
      const code = str.charCodeAt(i)
      if (code > 0x7f && code <= 0x7ff) s++
      else if (code > 0x7ff && code <= 0xffff) s += 2
      if (code >= 0xDC00 && code <= 0xDFFF) i--
    }
    return s
  },
  /**
   * 获取系统操作异常消息
   * @param ex
   * @returns {string}
   */
  getExceptionMessage(ex) {
    console.error('======system exception=====', ex)
    let errMsg = '系统出错啦，请反馈给管理员';
    if (ex.indexOf('Lock wait timeout exceeded') > -1) {
      errMsg = '系统繁忙，请稍后重试';
    }
    return errMsg;
  },

};
